import { useState, useContext, useEffect, forwardRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";
import { AccessContext } from "../../constant/accessContext";
import {
	getOrderHistory,
	getOrderBrazingLeak,
	allData_excel,
} from "../../constant/url";
import { BounceLoader } from "react-spinners";
import { DataGrid } from "@mui/x-data-grid";
import {
	Dialog,
	Button,
	Container,
	Tooltip,
	IconButton,
	Card,
	CardContent,
	Typography,
	Stack,
	DialogTitle
} from "@mui/material";
import Slide from "@mui/material/Slide";

import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from '@mui/icons-material/Close';

import StatusBar from "../modals/StatsBar";
import OrderViewModal from "../modals/OrderViewModal";
import OrderEditModal from "../modals/OrderEditModal";
import { saveAsExcel } from "../../commonjs/CommonFun";


const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrderHistory() {


	const navigate = useNavigate();
	const access = useContext(AccessContext).authID;
	const [orderList, setOrderList] = useState([]);
	const [allOrderList, setAllOrderList] = useState([]);
	const [BrazingLeakList, setBrazingLeakList] = useState([]);
	const [isUpdated, setIsUpdate] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [openOrderEdit, setOpenOrderEdit] = useState(false);
	const [openOrderView, setOpenOrderView] = useState(false);

	const handleOrderList = (authID) => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", authID);
		axios({
			method: "post",
			url: getOrderHistory,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data_orders;
					setOrderList(ret_data_cd);
					toast("Data Received.");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
		setIsUpdate(false);
	};

	const [Loading, setLoading] = useState(false);
	const [BdLoading, setBdLoading] = useState(false);


	const handleAllDataOrderList = async (authID) => {
		setLoading(true)
		var bodyFormData = new FormData();
		bodyFormData.append("authId", authID);
		bodyFormData.append("reqType", "history");
		axios({
			method: "post",
			url: allData_excel,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				console.log(response, "all history")
				const res_data = response.data;
				console.log(res_data, "all history")
				if (res_data.status_code === 101) {
					toast("Api Authentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data;
					// console.log(ret_data_cd);
					// // setAllOrderList(ret_data_cd);
					//   saveAsExcel(
					// 	ret_data_cd,
					// 	"Order History " + moment().format("YYYYMMDD H_mm").toString()
					// );

					// setLoading(false);


					saveAsExcel(
						ret_data_cd,
						"Order History " + moment().format("YYYYMMDD H_mm").toString()
					).then(() => {
						setLoading(false);
					}).catch(error => {
						console.error("Excel download failed:", error);
						setLoading(false);
					});
					toast("Excel Data Received.");
				} else {
					console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
		setIsUpdate(false);
	};

	const handleBrazingLeak = (authID) => {
		setBdLoading(true);

		var bodyFormData = new FormData();
		bodyFormData.append("authId", authID);

		axios({
			method: "post",
			url: getOrderBrazingLeak,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
			responseType: "blob", // ⭐ VERY IMPORTANT
		})
			.then((response) => {

				const blob = new Blob([response.data], {
					type: "application/vnd.ms-excel",
				});

				const url = window.URL.createObjectURL(blob);

				const link = document.createElement("a");
				link.href = url;
				link.download = "brazing_leak_report.xls";

				document.body.appendChild(link);
				link.click();

				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);

				setBdLoading(false);

			})
			.catch((error) => {
				console.error("Excel download failed:", error);
				setBdLoading(false);
			});

		setIsUpdate(false);
	};

	// const handleBrazingLeak = (authID) => {
	// 	setBdLoading(true)
	// 	var bodyFormData = new FormData();
	// 	bodyFormData.append("authId", authID);
	// 	axios({
	// 		method: "post",
	// 		url: getOrderBrazingLeak,
	// 		data: bodyFormData,
	// 		headers: { "Content-Type": "multipart/form-data" },
	// 	})
	// 		.then(function (response) {
	// 			const res_data = response.data;
	// 			if (res_data.status_code === 101) {
	// 				toast("Api Authentication failed. login again.");
	// 			} else if (res_data.status_code === 200) {

	// 				const ret_data_cd = res_data.data;
	// 				// saveAsExcel(res_data.data);
	// 				// setBrazingLeakList(ret_data_cd);
	// 				// setBdLoading(false)

	// 				saveAsExcel1(res_data.data).then(() => {
	// 					setBrazingLeakList(ret_data_cd);
	// 					setBdLoading(false);
	// 				}).catch(error => {
	// 					console.error("Excel download failed:", error);
	// 					setBdLoading(false);
	// 				});

	// 			} else {
	// 				console.log(res_data.status_msg);
	// 			}
	// 		})
	// 		.catch(function (response) {
	// 			console.log(response);
	// 		});
	// 	setIsUpdate(false);
	// };
	const handleCloseModal = (response) => {
		setOpenOrderView(false);
	};
	const columns = [
		{
			field: "order_id",
			headerName: "Order No",
			renderCell: (params) => {
				return (
					<Button
						onClick={() => {
							setSelectedRowId(params.row.id);
							setIsEdit(false);
							setOpenOrderView(true);
						}}
						color="info"
					>
						{params.row.order_id}{" "}
					</Button>
				);
			},
			flex: 1,
		},
		{
			field: "status",
			headerName: "Status",
			width: 200,
			renderCell: (params) => {
				return (
					<div className="position-relative">
						<StatusBar statusData={params.row} source="Table" />
					</div>
				);
			},
			flex: 1,
		},
		{
			field: "order_date",
			headerName: "Order Date",
			flex: 1,
		},
		{
			field: "full_customer_name",
			headerName: "Customer Name",
			width: 200,
			flex: 1,

			valueGetter: (params) => {
				return params.length > 18 ? params.slice(0, 18) + "..." : params;
			},
			renderCell: (params) => {
				return (
					<div title={params.row.full_customer_name}>
						{params.value}
					</div>
				);
			}

		},
		{
			field: "size",
			headerName: "Size",
			width: 150,
			flex: 1,
		},
		{
			field: "sq_feet",
			headerName: "Sq Feet",
			flex: 1,
		},
		{
			field: "Action",
			headerName: "Action",
			renderCell: (params) => {
				return (
					<Tooltip title="Re-Use Order History">
						<IconButton
							onClick={() =>
								navigate("/createOrder", {
									state: { orderRowid: params.row.id },
								})
							}
							name="re-use"
							color="success"
						>
							<HistoryEduIcon />
						</IconButton>
					</Tooltip>
				);
			},
			flex: 1,
		},
	];

	useEffect(() => {
		handleOrderList(access);
	}, []);

	useEffect(() => {
		if (isUpdated) {
			handleOrderList(access);
		}
	}, [isUpdated]);

	return (
		<Container>
			<ToastContainer />
			<Card>
				<CardContent>
					<Stack direction={"row"}>
						<Typography gutterBottom variant="h5" component="div">
							Order History
						</Typography>
						<Tooltip title="Download Excel list">
							<IconButton
								color="info"
								onClick={() => handleAllDataOrderList(access)}
							>
								{Loading ? <PuffLoader size={24} color="#943612" /> : <DownloadIcon />}
								<p>Order History</p>
							</IconButton>
						</Tooltip>
						<Tooltip title="Download Brazing Leak list">
							<IconButton
								color="info"
								onClick={() => handleBrazingLeak(access)}
							>
								{BdLoading ? <PuffLoader size={24} color="#943612" /> : <DownloadIcon />}
								<p>Brazing Details</p>
							</IconButton>
						</Tooltip>
					</Stack>
					<DataGrid
						getRowClassName={(params) =>
							params.indexRelativeToCurrentPage % 2 === 0
								? "Mui-even"
								: "Mui-odd"
						}
						sx={{
							"& .MuiDataGrid-columnHeader": {
								backgroundColor: "#943612",
								color: "white",
							},
							".MuiDataGrid-row.Mui-odd ": {
								backgroundColor: "#FFE1D6",
							},
							".MuiDataGrid-row.Mui-even ": {
								backgroundColor: "#F2F2F2",
							},
							".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
							{
								overflow: "visible !important",
							},
						}}
						rowHeight={50}
						columns={columns}
						rows={orderList}
						editMode="row"
					/>
				</CardContent>
			</Card>

			<Dialog
				fullWidth={true}
				maxWidth={"lg"}
				open={openOrderEdit}
				TransitionComponent={Transition}
				keepMounted
				onClose={() => setOpenOrderEdit(false)}
				key={Math.random(1, 100)}
			>
				<OrderEditModal
					orderId={selectedRowId}
					isUpdate={(status) => setIsUpdate(status)}
					isEdit={isEdit}
					key={Math.random(1, 100)}
				/>
			</Dialog>

			<Dialog

				fullWidth={true}
				maxWidth={"lg"}
				open={openOrderView}
				TransitionComponent={Transition}
				keepMounted
				onClose={() => setOpenOrderView(false)}
				key={Math.random(1, 100)}
			>
				<DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
					View Order Details
				</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleCloseModal}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
					id="order-view-close-btn"
				>
					<CloseIcon />
				</IconButton>
				<OrderViewModal orderId={selectedRowId} key={Math.random(1, 100)} />
			</Dialog>
		</Container>
	);
}
